import React from 'react';
export type Confidence = 'HIGH' | 'MEDIUM' | 'LOW';
interface ConfidenceTagProps {
  level: Confidence;
  className?: string;
}
const styles: Record<Confidence, string> = {
  HIGH: 'text-forest-green',
  MEDIUM: 'text-amber-600',
  LOW: 'text-red-500'
};
export function ConfidenceTag({
  level,
  className = ''
}: ConfidenceTagProps) {
  return <span className={`inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider ${styles[level]} ${className}`} data-id="element-2516" data-mp="1i8c448kqyum4">
      <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" data-id="element-2517" data-mp="1s4p5lsmjacrf" />
      {level} confidence
    </span>;
}